const requiredEnv = (name) => {
  const value = process.env[name]
  if (!value) throw new Error(`Missing env variable: ${name}`)
  return value
}

const appConfig = {
  apiBaseUrl: requiredEnv('REACT_APP_API_URL'),
  baseUrl: requiredEnv('REACT_APP_BASE_URL'),
  environment: requiredEnv('REACT_APP_ENV'),
  authenticatedEntryPath: '/project/dashboard',
  unAuthenticatedEntryPath: '/sign-in',
  tourPath: '/app/account/kyc-form',
  enableMock: false,
}

export default appConfig